import React, { Component } from 'react';

class Comentarios extends Component {

    render() {
        return (
            <div className="survey-question">
                <p className="survey-question-text">{this.props.name}</p>
                <textarea className="tall-textarea" cols="30" rows="10" onChange={this.props.callbackText}></textarea>
            </div>
        );
    }
}

export default Comentarios;


// WEBPACK FOOTER //
// ./src/components/Comentarios.js